import React, { useCallback, useState } from 'react'

import { BsWindow } from 'react-icons/bs'

import Radio from '@/Form/V2/Radio'
import Input from '@/Form/V2/Input'

import ECUsersAbondementsModal from '@Modal/ECUsersAbondementsModal'

import Message from '@Pure/Message'

import bemit from '@function/bemit'

import { formatNum } from '@root/utility'

const { app } = window;

const allowed_chars = [' ', '.', ',', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

export default function ECUsersAbondementsControls ({ onSuccess, ...props })
{
	const [value, setValue] = useState('');
	const [type, setType] = useState('add');
	const [modal, setModal] = useState({ });

	const handleTypeChange = useCallback(function (e)
	{
		setType(e?.target?.value || '');
	},
	[]);

	const handleValueChange = useCallback(function (e)
	{
		let value = Array.from(e.target.value || '')
		.filter(char => allowed_chars.includes(char))
		.join('')
		.split(',').join('.');

		setValue(value);
	},
	[]);

	const openModal = useCallback(function (e)
	{
		setModal({ trg: e.target, open: true });
	},
	[]);

	const closeModal = useCallback(function (e)
	{
		setModal({ });
	},
	[]);

	const has__selected = props.selected?.length > 0;
	const plural        = props.selected?.length > 1;

	const apply_label = has__selected ?
	(
		<>
			Appliquer (
			{ plural ? 'aux ' : 'à l\'' }
			{ plural ? props.selected.length : undefined }
			{ ' ' }
			utilisateur
			{ plural ? 's' : undefined }
			{ ' ' }
			sélectionné
			{ plural ? 's)' : ')' }
		</>
	)
	: 'Appliquer (sélectionnez au moins un utilisateur)';

	return (
		<>
			<div className="abondement-admin-table__add">
				<span className="abondement-admin-table__add-label">
					Montant&nbsp;:
				</span>

				<Input name="abondement-change"
					onChange={ handleValueChange }
					value={ value }
					bemit={ ['abondement-change'] }
				/>

				(disponible au CSE&nbsp;:
				{ ' ' }
				{ formatNum(props.total, '0,0[.]00') }
				{ ' ' }
				€)
			</div>

			<div className="abondement-admin-table__add">
				<span className="abondement-admin-table__add-label">
					Action&nbsp;:
				</span>

				<div className="u-full-width u-flex u-flex-wrap"
					style={ { gap: 30 } }>

					<Radio label="Ajouter"
						name="type"
						value="add"
						checked={ type === 'add' }
						onChange={ handleTypeChange }
					/>

					<Radio label="Retirer"
						name="type"
						value="sub"
						checked={ type === 'sub' }
						onChange={ handleTypeChange }
					/>

				</div>

			</div>

			<Message color="orange" className="u-margin-top-0">
				{
					type === 'sub'
					? 'Après soustraction, tout abondement négatif sera ramené à 0.'
					: undefined
				}
			</Message>

			<button type="button" onClick={ openModal }
				className={ bemit('c-btn', ['green', 'icon'].concat(!has__selected ? ['disabled'] : [])) }
				disabled={ !has__selected }>
				<BsWindow className="c-btn__icon" />
				{ apply_label }
			</button>

			<ECUsersAbondementsModal open={ modal?.open === true }
				onClose={ closeModal }
				value={ value }
				type={ type }
				onSuccess={ onSuccess }
				selected={ props.selected }
			/>
		</>
	);
}